import { PBL_DASHBOARD_FILTER_PARAM } from '@/components/Pbl/CaseList/dashboardFilter';
import type { PblDashboardCaseFilter } from '@/components/Pbl/CaseList/types';
import PATH from '@/router/path';
import type { PblDashboard } from '@/types/pbl';

const withDashboardFilter = (path: string, filter: PblDashboardCaseFilter) => {
  const searchParams = new URLSearchParams({ [PBL_DASHBOARD_FILTER_PARAM]: filter });
  return `${path}?${searchParams.toString()}`;
};

const citizenCardPaths: Record<string, string> = {
  total_cases: PATH.pbl.citizenCases,
  my_cases: PATH.pbl.citizenCases,
  pending_oc_review: withDashboardFilter(PATH.pbl.citizenCases, 'pending_oc_review'),
  pending_timeslot_selection: withDashboardFilter(PATH.pbl.citizenCases, 'pending_timeslot_selection'),
  upcoming_meetings: PATH.pbl.calendar,
  // Per-user evaluation state is counted by the dashboard but is not exposed by the case index.
  pending_rating: PATH.pbl.citizenCases,
};

const lawyerCardPaths: Record<string, string> = {
  assigned_cases: PATH.pbl.lawyerCases,
  pending_invitations: PATH.pbl.lawyerPendingReviewCases,
  pending_timeslot: withDashboardFilter(PATH.pbl.lawyerCases, 'pending_timeslot'),
  upcoming_meetings: PATH.pbl.calendar,
  // The case index does not expose signer-specific pending requests or per-user evaluation state.
  pending_signature: PATH.pbl.lawyerCases,
  pending_rating: PATH.pbl.lawyerCases,
};

const ocCardPaths: Record<string, string> = {
  office_cases: PATH.pbl.cases,
  total_cases: PATH.pbl.cases,
  pending_review: PATH.pbl.pendingReviewCases,
  matching_attention: withDashboardFilter(PATH.pbl.cases, 'matching_attention'),
  pending_selection: withDashboardFilter(PATH.pbl.cases, 'pending_appointment_confirmation'),
  pending_appointment_confirmation: withDashboardFilter(
    PATH.pbl.cases,
    'pending_appointment_confirmation'
  ),
  upcoming_meetings: PATH.pbl.calendar,
};

export const getPblDashboardCardPath = (role: PblDashboard['role'], cardKey: string) => {
  if (role === 'citizen') return citizenCardPaths[cardKey] || null;
  if (role === 'pbl_lawyer') return lawyerCardPaths[cardKey] || null;
  if (role === 'pbl_vetting_reviewer') {
    return cardKey === 'lawyer_vetting'
      ? `${PATH.pbl.vettingApplications}?status=pending_review`
      : null;
  }
  if (role === 'oc_admin' || role === 'oc_staff' || role === 'pbl_admin') {
    return ocCardPaths[cardKey] || null;
  }

  return null;
};
